import { ecoRebateData } from '@/utils/specificationHelper';
import WhereToBuyBtnEnhanced from '../button/where-to-buy-btn-enhanced';
import { RebaseEcoModal } from '../rebates';
import { useDeviceDetect } from '@/utils/useDeviceDetect';
import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { useMapStore } from '@/stores/map/mapStore';

interface WhereToBuyProps {
  slug?: string;
}

export const WhereToBuy = ({ slug }: WhereToBuyProps) => {
  const isMobile = useDeviceDetect();
  const [dispatchLength, setDispatchLength] = useState(0);
  const { setModalMapOpen, data } = useStore(useMapStore, (state) => ({
    setModalMapOpen: state.setModalMapOpen,
    data: state.data,
  }));

  useEffect(() => {
    setDispatchLength(data.dispatch?.length || 0);
  }, [data.dispatch]);

  return (
    <div className='mrc-sticky-footer__container  mx-auto flex h-16 w-full flex-row items-center justify-center gap-4 bg-white px-3 py-3 sm:py-5 md:px-4'>
      {isMobile && !dispatchLength && ecoRebateData[slug || ''] && (
        <div className='mrc-sticky-footer__rebate flex flex-1 justify-center text-center [&>button]:flex [&>button]:h-8 [&>button]:max-h-8 [&>button]:w-full [&>button]:items-center [&>button]:justify-center [&>button]:px-4 [&>button]:text-sm sm:[&>button]:h-10 sm:[&>button]:text-base [&>div]:flex [&>div]:h-8 [&>div]:items-center sm:[&>div]:h-10'>
          <RebaseEcoModal product={slug || ''} id='foter01' />
        </div>
      )}
      {!isMobile && ecoRebateData[slug || ''] && (
        <div className='mrc-sticky-footer__rebate flex flex-1 justify-center text-center [&>button]:flex [&>button]:h-8 [&>button]:max-h-8 [&>button]:w-full [&>button]:items-center [&>button]:justify-center [&>button]:px-4 [&>button]:text-sm sm:[&>button]:h-10 sm:[&>button]:text-base [&>div]:flex [&>div]:h-8 [&>div]:items-center sm:[&>div]:h-10'>
          <RebaseEcoModal product={slug || ''} id='foter01' />
        </div>
      )}

      <div
        className={`mrc-sticky-footer__where-to-buy flex flex-1 justify-center text-center [&>button]:flex [&>button]:h-8 [&>button]:max-h-8 [&>button]:w-full [&>button]:items-center [&>button]:justify-center [&>button]:pl-5 [&>button]:text-sm sm:[&>button]:h-10 sm:[&>button]:text-base`}
      >
        <WhereToBuyBtnEnhanced
          isMobile={isMobile}
          setMapOpen={setModalMapOpen}
          title='Where to Buy'
        />
      </div>
    </div>
  );
};
